export default __webpack_public_path__ + "static/media/Gilroy-Medium.9f1092d0.woff";